import React, { Component } from 'react';
import User from '../../../img/man.png';
import '../style.css';

const Users = ({ color, name }) => (
    <div style={{ marginTop: 5, marginBottom: 5, width: 250 }} className="d-flex flex-row justify-content-start align-items-center">
        <img className="image2" src={User} />
        <p style={{ marginLeft: 5, color: color }} className="rutasText">{name}</p>
    </div>
)

export default Users;



// WEBPACK FOOTER //
// ./src/Components/Rutas/Components/user.js